import React from 'react';

import './Card.scss';
import { Typography } from '../Typography/Typography';
import { Icon } from '../Icon/Icon';

import { ArrowLeft } from '@icons';
import { Button } from '../Buttons/Button/Button';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../Loader/Loader';



export type CardProps = {
    filled?: boolean;
    row?: boolean;
    showBack?: boolean;
    backTo?: string;
    isLoading?: boolean;
    headerType?: 'full' | 'light' | 'none' | 'very-light';
    headerTitle?: string | React.ReactNode;
    showHeader?: boolean;
    headerIcon?: React.ReactNode | string;
    headerAction?: React.ReactNode | string;
    headerStaticAction?: React.ReactNode | string;
    topActions?: React.ReactNode | string;
    noBorder?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Card: React.FC<CardProps> = ({
    children,
    filled,
    row,
    showBack,
    backTo,
    className,
    isLoading = false,
    headerTitle,
    showHeader = true,
    headerType,
    headerIcon,
    headerAction,
    headerStaticAction,
    topActions,
    noBorder = false,
    ...props
}) => {
    const navigate = useNavigate();
    return (<>
    {(showBack || topActions) && (
        <div className="card-header-actions">
            {showBack && (
                <Button onClick={() => backTo ? navigate(backTo) : navigate(-1)} variant="tertiary" color="grey-primary" size="small" icon={<Icon icon={<ArrowLeft />} size={10} color="grey1" />}>Retour</Button>
            )}
            {topActions && <div className="card-top-actions">{topActions}</div>}
            </div>
        )}
        <div data-filled={filled} data-row={row} className={`card ${headerType ?? ''} ${className ?? ''} ${noBorder ? 'no-border' : ''}`} {...props}>
            {isLoading && <Loader className="card-loader" />}
            {showHeader && headerType !== 'none' && (<>
                <div className={`card-header`}>
                    <div className="card-header-left">
                        {headerIcon && headerIcon}
                        {headerTitle && (
                            <Typography intrinsic="h3" color="secondary">
                                {headerTitle}
                            </Typography>
                        )}
                    </div>
                    <div className="card-header-right">{headerAction && headerAction}</div>
                    <div className="card-header-static-action">{headerStaticAction && headerStaticAction}</div>
                </div>
            </>)}
            <div className="card-content">{children}</div>
        </div>
    </>);
};
